export default {
  namespaced: true,
  state: {
    popupActive: false,
    isLoading: false,
    message: '',
  },
  mutations: {
    OPEN(state) {
      state.popupActive = true;
      state.isLoading = true;
      state.message = '';
    },
    CLOSE(state) {
      state.popupActive = false;
      state.isLoading = false;
      state.message = '';
    },
    SHOW_ERROR(state, payload) {
      state.isLoading = false;
      state.message = payload || '';
    },
  },
  actions: {
    open({ commit }) {
      commit('OPEN');
    },
    close({ commit }) {
      commit('CLOSE');
    },
    showError({ commit }, message) {
      commit('SHOW_ERROR', message);
    },
  },
};
